"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DonutUtilizationStyles = void 0;
const tslib_1 = require("tslib");
const chart_donut_threshold_warning_Color_1 = tslib_1.__importDefault(require('@patternfly/react-tokens/dist/js/chart_donut_threshold_warning_Color'));
const chart_donut_threshold_danger_Color_1 = tslib_1.__importDefault(require('@patternfly/react-tokens/dist/js/chart_donut_threshold_danger_Color'));
/**
 * Donut utilization styles
 *
 * @private Not intended as public API and subject to change
 */
exports.DonutUtilizationStyles = {
    thresholds: {
        colorScale: [chart_donut_threshold_warning_Color_1.default.var, chart_donut_threshold_danger_Color_1.default.var]
    }
};
//# sourceMappingURL=donut-utilization-styles.js.map